import * as z from "zod/v4";

/**
 * The destination countries enabled in the store's Shopify Markets. Spotlight
 * geo-targeting can only meaningfully gate on these: the storefront's shopper
 * country (Shopify's Liquid `localization.country`) only ever resolves to an
 * enabled market, so targeting a non-market country never triggers. The
 * settings UI restricts its country picker to this list and hides the whole
 * geo-targeting section when it's empty (markets not configured).
 */
export const getSpotlightMarketCountries = {
  name: "getSpotlightMarketCountries" as const,
  input: z.null(),
  output: z.object({
    countries: z.array(z.object({ code: z.string(), name: z.string() })),
  }),
};
